module.exports = __webpack_public_path__ + "static/media/Replacement pH Controller Tubing (13ft  4m).4754ca62.webp";